import { IGSTDetails } from "repoV2/features/Common/modules/FormData/interfaces/GSTDetailsFormGroup.interfaces";
import { IRenewSubscriptionDetails } from "repoV2/features/Common/modules/FormData/interfaces/IRenewSubscriptionDetails";
import { ICustomer } from "../Payments.interface";

export const generateRenewSubscriptionCustomerDetails = (data: {
    renewSubscriptionDetails: IRenewSubscriptionDetails;
    gstDetails: IGSTDetails;
}) => {
    const { renewSubscriptionDetails = {}, gstDetails = {} } = data;

    const customerArray: ICustomer[] = [
        {
            email: renewSubscriptionDetails?.email,
            ...(renewSubscriptionDetails.billing_state?.value && {
                billing_state: renewSubscriptionDetails.billing_state.value,
            }),
            ...(gstDetails.active && {
                gst_info: {
                    gst_number: gstDetails.registration_number,
                    gst_name: gstDetails.company_name,
                    gst_company_address: gstDetails.company_address,
                    pincode: gstDetails.company_pincode,
                },
            }),
        },
    ];

    return customerArray;
};
